import React from 'react';

import styles from './step-container.module.scss';
export const LoaderContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className ? `${styles['loader-container']} ${className}` : styles['loader-container']
    }
    {...props}
  />
);
